export default {
    '您的银行户口尚未开通。': '',
    '您的银行户口审核中。': '',
    '当前户口销户中，请耐心等待': '',
    '受金管局监管要求，您需通过本人户口存入500以上金额的港币方能使用本户口': '',
    '系统繁忙, 请稍后再试': '',
    我知道了: '',
    立即激活: '',
    立即开通: '',
    温馨提示: '',
    '错误码：': '',
};
